"use client";
import { showSideMenuAtom } from "@/hooks/showSideMenuAtom";
import { useAtom } from "jotai";
import { Link } from "@/app/components/lib/navigation/Link";
import { NavLink } from "@/utils/bootstrap";
import MobileMenuItemTitle from "./mobile/MobileMenuItemTitle";
import PCMenuItemTitle from "./pc/PCMenuItemTitle";

interface Props {
  title: {
    Svg?: any;
    url?: string;
    text?: string;
    other?: any;
  };
  isMobile?: boolean;
  href?: string;
  onClick?: () => void;
  eventKey?: string;
  active?: boolean;
  isFooter?: boolean;
  autoClose?: boolean;
}

const MenuLink: React.FC<Props> = ({
  isMobile = false,
  href = null,
  onClick,
  title,
  eventKey,
  active = false,
  isFooter,
  autoClose = true,
}) => {
  const [, setShowSideMenu] = useAtom(showSideMenuAtom);
  const Action = (
    <NavLink
      className={isFooter && !isMobile ? "footer-menu-nav-link" : ""}
      as="span"
      eventKey={eventKey}
      active={active}
      // active={currentPath === href}
      onClick={() => {
        isMobile && autoClose && setShowSideMenu(false);
        onClick?.();
        // setTimeout(() => onClick?.(), 500);
      }}
    >
      {isMobile ? (
        <MobileMenuItemTitle
          title={title}
          isFooter={isFooter!}
          textDecoration={!autoClose}
        />
      ) : (
        <PCMenuItemTitle title={title} />
      )}
    </NavLink>
  );

  return href ? (
    <Link href={href} prefetch={false}>
      {Action}
    </Link>
  ) : (
    Action
  );
};
export default MenuLink;
